import React, { useEffect, useState } from "react";
import { upcomingEvents } from "../apis/apis";
import { Link } from "react-router-dom";

const UpcomingActiviites = () => {
  const [upcomingActivities, setUpcomingActivities] = useState([]);
  useEffect(() => {
    getAllUpcomingActivities();
  }, []);
  const getAllUpcomingActivities = async () => {
    try {
      const response = await upcomingEvents();
      setUpcomingActivities(response);
    } catch (error) {
      console.log("getAllUpcomingActivities error", error);
    }
  };
  return (
    <>
      <div>
        <p style={{ color: "#000", fontWeight: "700" }}>
          Upcoming Activities
        </p>
      </div>
      <div>
        {upcomingActivities?.length > 0 ? (
          upcomingActivities.map((item: any, index: number) => (
            <Link to="/calendar" style={{color:"black"}}>
            <div
              key={index}
              className="activity-card"
              style={{
                border: "1px solid #e0e0e0",
                borderRadius: "8px",
                overflow: "hidden",
                margin: "10px 0",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
              }}
            >
              {item.image && (
                <div style={{ height: "150px", overflow: "hidden" }}>
                  <img
                    src={process.env.REACT_APP_PUBLIC_IMAGE_URL + item.image}
                    alt={item.title}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover"
                    }}
                  />
                </div>
              )}
              <div style={{ padding: "12px" }}>
                <h3 style={{ margin: "0 0 8px 0", fontSize: "16px" }}>
                  {item.title}
                </h3>
                {item.start_date && (
                  <p
                    style={{
                      color: "#000",
                      fontWeight: "300",
                      margin: "0",
                      fontSize: "14px"
                    }}
                  >
                    {Math.max(
                      0,
                      Math.ceil(
                        (new Date(item.end_date).getTime() -
                          new Date().getTime()) /
                          (1000 * 60 * 60 * 24)
                      )
                    )}{" "}
                    days left
                  </p>
                )}
                {item.limit_to && (
                  <p
                    style={{
                      color: "#868686",
                      fontSize: "13px",
                      margin: "4px 0 0 0"
                    }}
                  >
                    {item.limit_to}
                  </p>
                )}
              </div>
            </div>
            </Link>
          ))
        ) : (
          <div>No upcoming activities</div>
        )}
      </div>
    </>
  );
};

export default UpcomingActiviites;
